module.exports = __webpack_public_path__ + "static/media/IMG-1.b0586b11.jpg";